import getSingle from "./get-single.js";
import getAll from "./get-all.js";
import getSingleInstance from "./get-single-instance.js";

export default {
	getSingle,
	getAll,
	getSingleInstance,
};
